// Header scroll effect + mobile bottom CTA visibility
const header = document.querySelector(".r3-v4__header");
const mobileBottomCta = document.querySelector(".r3-v4__mobile-bottom-cta");

window.addEventListener("scroll", () => {
  const isScrolled = window.scrollY > 50;
  header.classList.toggle("scrolled", isScrolled);

  // Show/hide mobile bottom CTA on scroll (same timing as header color change)
  if (mobileBottomCta) {
    mobileBottomCta.classList.toggle("visible", isScrolled);
  }
});

// FAQ Accordion
document.querySelectorAll(".r3-v4__faq-question").forEach((q) => {
  q.addEventListener("click", () => {
    const item = q.parentElement;
    document
      .querySelectorAll(".r3-v4__faq-item")
      .forEach((i) => i !== item && i.classList.remove("active"));
    item.classList.toggle("active");
  });
});

// Scroll animation observer
const scrollObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  },
  { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
);

document.querySelectorAll(".animate-on-scroll").forEach((el) => {
  scrollObserver.observe(el);
});

// Comparison chart scale animation
const compareChart = document.querySelector(".r3-v4__compare-svg");
const compareSection = document.querySelector(".r3-v4__compare");
if (compareChart && compareSection) {
  window.addEventListener("scroll", () => {
    const rect = compareSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      const scrollProgress = Math.min(
        1,
        Math.max(0, (windowHeight - rect.top) / (windowHeight * 0.6)),
      );
      const scale = 0.9 + scrollProgress * 0.1;
      compareChart.style.transform = `scale(${scale})`;
    }
  });
}

// Parallax effect for Trusted modal - Apple-style subtle movement
const trustedModal = document.querySelector(".r3-v4__trusted-modal");
const trustedSection = document.querySelector(".r3-v4__trusted");

// Initial visibility observer
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (trustedModal) trustedModal.classList.add("visible");
      }
    });
  },
  { threshold: 0.15 },
);
if (trustedModal) observer.observe(trustedModal);

// Subtle parallax on scroll
if (trustedModal && trustedSection) {
  window.addEventListener("scroll", () => {
    const rect = trustedSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      const scrollProgress =
        (windowHeight - rect.top) / (windowHeight + rect.height);
      const parallaxOffset = (scrollProgress - 0.5) * 20;
      trustedModal.style.transform = `translateY(${parallaxOffset}px)`;
    }
  });
}

// Dynamic timeline dates
(function () {
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var now = new Date();

  function getPrefix(day) {
    if (day <= 10) return "Early ";
    if (day <= 20) return "Mid ";
    return "Late ";
  }

  function formatDate(d) {
    return getPrefix(d.getDate()) + months[d.getMonth()];
  }

  var els = document.querySelectorAll(".r3-v4__whatis-phase-dates");
  els.forEach(function (el) {
    var startWeek = parseInt(el.getAttribute("data-start"), 10);
    var endWeek = parseInt(el.getAttribute("data-end"), 10);
    var startDate = new Date(now.getTime() + (startWeek - 1) * 7 * 86400000);
    var endDate = new Date(now.getTime() + endWeek * 7 * 86400000);
    var startStr = formatDate(startDate);
    var endStr = formatDate(endDate);
    if (startStr === endStr) {
      el.textContent = startStr;
    } else {
      el.textContent = startStr + " – " + endStr;
    }
  });
})();
